import * as React from 'react'

import { ArrowRightIcon } from 'lucide-react'
import { action, makeObservable } from 'mobx'
import { observer } from 'mobx-react'

import DesktopDeliveryViewStore from '~/client/src/desktop/views/Deliveries/DesktopDeliveryView.store'
import { NOOP } from '~/client/src/shared/utils/noop'

// localization: no display text to translate

interface IProps {
  store?: DesktopDeliveryViewStore
  title: string
  content: JSX.Element
  handleClose?: () => void
  header?: JSX.Element
  subTitle?: string
  shouldShowHeader?: boolean
}

@observer
export default class DeliveryActionSideBase extends React.Component<IProps> {
  public static defaultProps = {
    subTittle: '',
    handleClose: NOOP,
    shouldShowHeader: true,
  }

  public constructor(props: IProps) {
    super(props)
    makeObservable(this)
  }

  public render() {
    const { content } = this.props

    return (
      <div className="desktop-deliveries-details col">
        {this.renderHeader()}
        <div className="full-height overflow-hidden">{content}</div>
      </div>
    )
  }

  private renderHeader(): JSX.Element {
    const { header, shouldShowHeader, title, subTitle } = this.props
    if (!shouldShowHeader) return null
    if (header) return header

    return (
      <div className="row pa10 pl20 bb-light-grey">
        <div className="no-grow col y-center" onClick={this.handleClose}>
          <ArrowRightIcon
            size={25}
            className="pointer tw:shrink-0 tw:text-primary"
          />
        </div>
        <div className="col ml10">
          <div className="text primary-blue extra-large bold uppercase">
            {title}
          </div>
          <div className="text light large bold uppercase">{subTitle}</div>
        </div>
      </div>
    )
  }

  @action.bound
  private handleClose() {
    const { store, handleClose } = this.props
    if (store) {
      store.resetActionType()
    }
    handleClose()
  }
}
